import React from "react";
import { Link } from "react-router-dom";
import { destacadosDe } from "./destacadosPorCarrera";

// Panel "lo más consultado por carrera". Recibe la carrera del alumno y
// muestra los accesos recomendados desde la config curada.
const DashDestacados = ({ carrera }) => {
    const items = destacadosDe(carrera);

    const cuerpo = (item) => (
        <>
            <span className="esen-dash-link-icon">
                <i className={`fa ${item.icon}`} aria-hidden="true"></i>
            </span>
            <span className="esen-dash-link-text">
                <span className="esen-dash-link-label">{item.label}</span>
                {item.descripcion ? (
                    <span className="esen-dash-link-desc">{item.descripcion}</span>
                ) : null}
            </span>
            <i className="fa fa-angle-right esen-dash-link-chevron" aria-hidden="true"></i>
        </>
    );

    return (
        <div className="card h-100">
            <div className="card-header">
                <i className="fa fa-star mr-2" aria-hidden="true"></i>
                Lo más consultado{carrera ? ` · ${carrera}` : ""}
            </div>
            <div className="card-body">
                <ul className="esen-dash-links">
                    {items.map((item) => (
                        <li key={item.label}>
                            {item.externo ? (
                                <a
                                    href={item.to}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="esen-dash-link"
                                >
                                    {cuerpo(item)}
                                </a>
                            ) : (
                                <Link to={item.to} className="esen-dash-link">
                                    {cuerpo(item)}
                                </Link>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default DashDestacados;
